import styled, { css } from 'styled-components'
import { InnerContainer } from '../../layouts/Default'
import { media } from '../../layouts/utils'

export const InnerContainerListaPassoAPasso = styled(InnerContainer)`
  padding-left: 0;
`

export const ContainerList = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  //padding-left: 48px;
  flex-direction: ${({ tamanhoListaCards }) =>
    tamanhoListaCards === 2 ? 'column' : 'row'};
  ${(botaoEmbaixo) =>
    botaoEmbaixo &&
    css`
      flex-direction: column;
    `}

  ${media.phone`
      margin-top: 0px;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 48px;
  `}

  ul {
    li {
      button: {
        content: '';
      }
    }
  }
`

export const SpacerCards = styled.div`
  background-image: ${(props) =>
    props.index === 0
      ? 'none'
      : props.flip
      ? `url(${props.imagemAux})`
      : `url(${props.imagem})`};
  margin: 0;
  padding-left: 0;
  background-repeat: no-repeat;
  background-size: 100px;
  background-position-x: 10px;
  background-position-y: 80px;
`

export const Imagem1 = styled.img`
  height: 80px;
  position: relative;
  left: 28%;
  top: 200px;
  margin-top: -80px;

  ${media.desktop`
      display: none;
    `}
`

export const ContainerListButton = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  justify-content: space-evenly;
  padding-left: 170px;
  padding-right: 170px;

  ${media.phone`
      padding-left: 24px;
      padding-right: 0px;
      padding-bottom: 48px;
  `}
`

export const Imagem = styled.img`
  height: 70px;
  position: relative;
  top: 200px;
  margin-top: -80px;

  ${media.desktop`
      display: none;
    `}
`
export const Botao = styled.div`
  position: relative;
  top: 200px;
  margin-top: -80px;
`

export const BotaoTwoCard = styled.div`
  align-self: center;
  margin-top: 24px;
`

export const Imagem2 = styled.img`
  height: 70px;
  position: relative;
  left: 53%;
  top: 200px;
  margin-top: -80px;

  ${media.desktop`
      display: none;
    `}
`
export const LeftArrow = styled.img.attrs(props => ({
  src: '/parcerias/assets/chevron-left-turquoise.png'
}))`
  position: absolute;
  width: 32px;
  height: 32px;
  left: 5%;
  top: 140px;
  cursor: 'pointer';
  outline: none;
  z-index: 1;
  display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
`

export const RightArrow = styled.img.attrs(props => ({
  src: '/parcerias/assets/chevron-right-turquoise.png'
}))`
  position: absolute;
  width: 32px;
  height: 32px;
  right: 5%;
  top: 140px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  outline: none;
  z-index: 1;
  display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
`
